import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface CountdownBannerProps {
  text: string;
  endDate: string; // ISO string, e.g. "2026-04-18T23:55:00Z"
}

const getTimeRemaining = (endDate: string) => {
  const end = new Date(endDate).getTime();
  const now = Date.now();
  const total = end - now;

  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return { total, days, hours, minutes, seconds };
};

const CountdownBanner: React.FC<CountdownBannerProps> = ({ endDate, text }) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeRemaining(endDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining(endDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  if (timeLeft.total <= 0) {
    return <div style={{ padding: '1em', background: '#ffeaea', color: '#a00' }}>Subscription period has ended.</div>;
  }

  return (
    <Typography variant="body1">
      {text}{' '}
      <strong>
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
      </strong>
    </Typography>
  );
};

export default CountdownBanner;
